
const contents = "mutation UpdateAppActivityStateClients($input: UpdateAppActivityStateInput!) {\n  updateAppActivityState(input: $input) {\n    userId\n  }\n}\n";
const sha256Hash = "e2a221e7add885fd49c35ea6c12494fff5720804c60c08742f7c307e6c6f5637";
export default { contents: contents, sha256Hash: sha256Hash };
